export const languages = [
    {
        value: 'en',
        label: 'English',
    },
];
